'use client';

import { DialogTitle } from '@headlessui/react';
import classNames from '@/utils/classNames';

import type { ModalTitleProps } from './Modal.types';

const baseClassName = [
  'group-[.sm]/modal:text-xl',
  'group-[.lg]/modal:text-2xl',
  'group-[.lg]/modal:font-semibold',
  'group-[.md]/modal:text-3xl',
  'group-[.medium]/modal:text-lg',
  'group-[.medium]/modal:font-semibold',
  'group-[.drawer]/modal:text-2xl',
  'group-[.sm]/modal:mr-8',
  'group-[.md]/modal:mr-9',
  'group-[.drawer]/modal:mr-9',
  'group-[.full]/modal:text-2xl',
  'group-[.full]/modal:font-semibold',
  'text-greyscale-950',
];

const Title = <T extends React.ElementType = 'h1'>({
  children,
  className,
  ...props
}: ModalTitleProps<T>) => (
  <DialogTitle className={classNames(baseClassName, className)} {...props}>
    {children}
  </DialogTitle>
);

export default Title;
